(ns arthur.ui.openmenu
  "File → Open. The projects the server holds, and nothing else.

  IT IS NOT THE MEDIA POOL. A project is a whole document — opening one replaces
  the stage — and the pool is the open document's own library. Listing documents
  beside the symbols inside one of them makes them look like two kinds of the
  same thing, which is the confusion this split exists to end.

  The built-in scenes are under their own heading and are NOT projects: they are
  compiled into the bundle, the server has never heard of them, and `demo/scene`
  and the swarm exist to exercise and to profile the model rather than to be
  worked on. They are here because there is nowhere else for a fixture to live,
  and they are labelled so that nothing about them reads as a saved document."
  (:require [arthur.db :as db]
            [arthur.events.playback :as pb]
            [arthur.events.project :as project]
            [arthur.subs.playback :as playback]
            [re-frame.core :as rf]
            [reagent.core :as r]))

(defn- when-said
  "The ISO stamp the server sends, as a date. Truncated rather than formatted:
  a list of documents wants to be sorted and scanned, not read to the second."
  [iso]
  (when iso (subs (str iso) 0 10)))

(defn- item
  "One row. `example?` is not decoration: the server is full of documents called
  \"take\", so \"the row labelled take\" does not identify one thing — the class is
  what lets a reader, and `test/browser`, tell a saved project from the fixture
  that shares its name."
  [{:keys [label sub on-click disabled? example?]}]
  [:button {:class (str "menu-item" (when example? " example"))
            :on-click on-click :disabled (boolean disabled?) :title label}
   label
   (when sub [:span.sub sub])])

(defn view []
  (r/with-let [open? (r/atom false)]
    (let [{:keys [items loading?]} @(rf/subscribe [::project/listing])
          busy? (:busy? @(rf/subscribe [::playback/project]))
          choose! (fn [event] (reset! open? false) (rf/dispatch event))]
      [:div.menu-wrap
       [:button {:disabled busy?
                 :class (when @open? "on")
                 :on-click (fn []
                             (when-not @open? (rf/dispatch [::project/list]))
                             (swap! open? not))}
        "open ▾"]
       (when @open?
         [:<>
          ;; A full-page catcher behind the panel, so clicking anywhere else
          ;; dismisses it. Cheaper and more predictable than a document-level
          ;; listener that has to be added, removed and told to ignore the click
          ;; that opened the menu.
          [:div.menu-scrim {:on-click #(reset! open? false)}]
          [:div.menu
           [:h2 "projects"]
           (cond
             loading?        [:div.dim "…"]
             (empty? items)  [:div.dim "none saved yet"]
             :else
             (doall
              (for [{:keys [id name seq updated]} items]
                ^{:key id}
                [item {:label (or name "untitled")
                       :sub (str "r" seq " · " (when-said updated))
                       :on-click #(choose! [::project/open id])}])))
           [:h2 "built-in examples"]
           [:div.dim "compiled in, not saved documents"]
           (doall
            (for [[id {:keys [label]}] db/clips]
              ^{:key id}
              [item {:label label :example? true
                     :on-click #(choose! [::pb/select-clip id])}]))
           [item {:label "8625 stage study" :example? true
                  :sub "composed from a locally saved project"
                  :on-click #(choose! [::project/load-stage])}]]])])))
